import React from "react";
import logo from "../../img/ctlogo_color.png";
// import proDmsLogo from "../../img/prodms_bw.png";
// import osc_bw from "../../img/osc_bw.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/nav.css";

const LogoBar = ({ fetching }) => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-4 mx-2 my-1 px-0 d-inline-flex">
          <div className="ml-2 mr-0 p-1">
            {/* If using ProDMS logo, use width="78" height="30" */}
            <img src={logo} alt="Caltrans - ProDMS" width="143" height="22" />
          </div>
          {/* If using ProDMS logo, use mt-1 */}
          <div className="dms-title mx-2 mt-2 px-1 py-0">
            <small>
              <strong>ProDMS</strong>
            </small>
          </div>
          {fetching && (
            <span className="ml-1 mt-1">
              <FontAwesomeIcon icon="spinner" className="loading-spinner" />
            </span>
          )}
        </div>
        <div className="col-3 px-0" />
        <div className="col-4 px-0 m-1 ml-auto">
          <div className="float-right">
            {/* <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Search Text..."
                aria-label="Search"
              />
              <div className="input-group-append">
                <button className="btn btn-outline-secondary" type="button">
                  Search
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoBar;
